import {createStyles} from '@material-ui/core/styles';

const styles = () => createStyles({
  filters__switchGroup: {
    'display': 'flex',
    'flexDirection': 'row',
    'justifyContent': 'space-between',
    'paddingLeft': '20px',
    'paddingRight': '20px',
    '@media (max-width: 800px)': {
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
  },
  organizations__searchField: {
    'width': '60%',
    '@media (max-width: 800px)': {
      width: '100%',
    },
  },
});

export default styles;
